import { render, staticRenderFns } from "./Script.vue?vue&type=template&id=bdd83f5c&scoped=true&"
import script from "./Script.vue?vue&type=script&lang=js&"
export * from "./Script.vue?vue&type=script&lang=js&"
import style0 from "./Script.vue?vue&type=style&index=0&id=bdd83f5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd83f5c",
  null
  
)

export default component.exports